import React from 'react';
import cx from 'classnames';

import Navigation from 'components/Navigation';

import { navigationLinks } from 'utils/helpers/navigation';
import { socialsList } from 'utils/helpers/socials';

import About from './components/About';
import Copyright from './components/Copyright';
import Sidebar from './components/Sidebar';
import SocialLinks from './components/SocialLinks';
import Subscription from './components/Subscription';

import styles from './styles.module.scss';

const Footer = () => (
	<footer
		className={styles.footer}
		tabIndex={0}
		aria-label="Подвал сайта"
		role="navigation"
		aria-hidden="true"
	>
		<div className={styles.main}>
			<div className={cx(styles.content, styles.main)}>
				<div className={styles.row}>
					<div>
						<div className={styles.navigation}>
							<Navigation
								primacy="primary"
								data={navigationLinks.secondary}
								theme="footer"
								color="pale"
								parentTabIndex={0}
							/>
						</div>
					</div>
				</div>
				<div className={cx(styles.row, styles.morphing_borderNone)}>
					<Subscription />
				</div>
				<div className={styles.row}>
					<About />
				</div>
				<div className={styles.row}>
					<div className={styles.addition}>
						<div className={styles.block}>
							<Copyright />
						</div>
						<div className={styles.block}>
							<SocialLinks data={socialsList} />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className={styles.sidebar}>
			<div className={cx(styles.content, styles.sidebar)}>
				<Sidebar />
			</div>
		</div>
	</footer>
);

export default Footer;
